import React, { useState } from 'react';

import Image from '@atlaskit/image';

type ImageFromUrlProps = {
	alt?: string;
	fallback?: React.ReactNode;
	src?: string;
	testId?: string;
};

export const ImageFromUrl = ({ src, alt, fallback, testId }: ImageFromUrlProps) => {
	const [hasError, setHasError] = useState(false);

	if (!src || hasError) {
		return fallback;
	}

	return (
		<Image
			src={src}
			alt={alt}
			onError={() => {
				setHasError(true);
			}}
			testId={testId}
		/>
	);
};
